import * as Fetch from '@/helpers/fetch'

export const getOffers = async (
  token: string,
  type?: string,
  sortQuery?: string
): Promise<Fetch.HttpResponse> => {
  const query = [type ? `type=${type}` : '', sortQuery ?? ''].filter(Boolean).join('&')
  const url = `${process.env.VUE_APP_MY_COUPON_SERVICE_URL}/v1/offers${query ? `?${query}` : ''}`
  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
      channel: 'line',
      'Accept-Language': 'th'
    },
  }
  try {
    const result = await Fetch.get(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}